import { createTheme } from '@mui/material/styles';
import { ThemeConfig, AppTheme } from './types';
import { 
  industrialSlateLight, 
  industrialSlateDark,
  nordicMinimalLight,
  nordicMinimalDark
} from './themes';

// Available theme presets
export const themePresets = {
  industrialSlate: {
    light: industrialSlateLight,
    dark: industrialSlateDark,
  },
  nordicMinimal: {
    light: nordicMinimalLight,
    dark: nordicMinimalDark,
  },
};

export const createAppTheme = (config: ThemeConfig & { preset?: keyof typeof themePresets }): AppTheme => {
  // Use the specified preset or default theme
  const preset = config.preset || 'nordicMinimal';
  const themeOptions = config.mode === 'dark' 
    ? themePresets[preset].dark 
    : themePresets[preset].light;
  
  return createTheme(themeOptions) as AppTheme;
};